/**
 * Created By Elia Rohana on 12/2/18
 */
import { State } from '../state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from './bpmn-modeler-state.selector';

const getNodesConfigurations = (state: State): any => state.nodesConfigurations;

export const selectNodesConfigurations: MemoizedSelector<
    object,
    string
    > = createSelector(selectBpmnModelerState, getNodesConfigurations);
